(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-revalt-catalog]').forEach((catalog) => {
      if (catalog.dataset.initialized) return;
      catalog.dataset.initialized = 'true';
      const filters = catalog.querySelector('.r2-filters');
      const cards = [...catalog.querySelectorAll('.r2-card[data-category]')];
      const count = catalog.querySelector('[data-result-count]');
      const empty = catalog.querySelector('[data-filter-empty]');
      filters.hidden = false;
      filters.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        let visible = 0;
        cards.forEach((card) => {
          card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter;
          if (!card.hidden) visible += 1;
        });
        count.textContent = `${visible} ${visible === 1 ? 'piece' : 'pieces'}`;
        empty.hidden = visible !== 0;
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
